import {GenericoTipoEnum} from "../../bibliotecaPjus/enums/enumGenerico.enum";

export enum StatusNegociacao {
  GerandoOferta = 'GerandoOferta',
  AceiteContraOferta = 'AceiteContraOferta',
  RecusaContraOferta = 'RecusaContraOferta',
  NovaOfertaPjus = 'NovaOfertaPjus'
}

export class StatusNegociacaoEnum extends GenericoTipoEnum<StatusNegociacao> {
  static readonly GerandoOferta = new StatusNegociacaoEnum(StatusNegociacao.GerandoOferta, 'Gerando Oferta');
  static readonly AceiteContraOferta = new StatusNegociacaoEnum(StatusNegociacao.AceiteContraOferta, 'Aceite Contra Oferta');
  static readonly RecusaContraOferta = new StatusNegociacaoEnum(StatusNegociacao.RecusaContraOferta, 'Recusa Contra Oferta');
  static readonly NovaOfertaPjus = new StatusNegociacaoEnum(StatusNegociacao.NovaOfertaPjus, 'Nova Oferta Pjus');
}
